import React from 'react'

const Bolivia = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <rect
            x="4.4"
            y="4.4"
            width="31.2"
            height="31.2"
            rx="15.6"
            stroke="#BCBCBC"
            strokeWidth="0.8"
        />
        <mask
            id="footer-flag-bolivia"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="8"
            y="8"
            width="24"
            height="24"
        >
            <path
                d="M20 32C23.1826 32 26.2348 30.7357 28.4853 28.4853C30.7357 26.2348 32 23.1826 32 20C32 16.8174 30.7357 13.7652 28.4853 11.5147C26.2348 9.26428 23.1826 8 20 8C16.8174 8 13.7652 9.26428 11.5147 11.5147C9.26428 13.7652 8 16.8174 8 20C8 23.1826 9.26428 26.2348 11.5147 28.4853C13.7652 30.7357 16.8174 32 20 32Z"
                fill="#C4C4C4"
            />
        </mask>
        <g mask="url(#footer-flag-bolivia)">
            <path d="M51.0667 4.26562H8V14.719H51.0667V4.26562Z" fill="#BC2433" />
            <path d="M51.0667 14.7188H8V25.1721H51.0667V14.7188Z" fill="#F0D633" />
            <path d="M51.0667 25.1719H8V35.6252H51.0667V25.1719Z" fill="#347B47" />
        </g>
    </svg>
)

export default Bolivia
